import React from "react";
import { Link } from "react-router-dom";

import { bdtFmt } from "../components/investor/InvestorTxnDetailUi";
import { INVESTOR_HISTORY_PAGE_TITLE } from "./historyModuleConfig";
import { TRANSFERABLE_PROJECTS_LABEL } from "./investorNavConfig";
import { formatShareQty } from "./investorRedeemEligibility";

/** Message body for InvestmentsPage action-success overlay after transfer submit. */
export function transferRequestSuccessMessage(data, project) {
  const ref = data?.transfer_ref;
  const shares = data?.shares != null ? formatShareQty(data.shares) : null;
  const recipient = data?.transfer_recipient_display;
  const nav = Number(data?.price_per_share || 0);
  const code = project?.project_code || "N/A";
  const name = project?.name || "this project";

  return (
    <>
      {ref ? (
        <>
          Reference <strong>{ref}</strong>.{" "}
        </>
      ) : null}
      {shares ? (
        <>
          <strong>{shares}</strong> shares offered
          {recipient ? (
            <>
              {" "}
              to <strong>{recipient}</strong>
            </>
          ) : null}
          {nav > 0 ? (
            <>
              {" "}
              at locked NAV <strong>{bdtFmt.format(nav)}</strong>/share
            </>
          ) : null}
          .{" "}
        </>
      ) : null}
      NAV-locked offer for <strong>{name}</strong> (<strong>{code}</strong>). The recipient must accept before
      settlement; your holdings are unchanged until then. Track pending offers on{" "}
      <Link to="/investments/transfers">{TRANSFERABLE_PROJECTS_LABEL}</Link> and in{" "}
      <Link to="/my-history/transfers">{INVESTOR_HISTORY_PAGE_TITLE}</Link> (transfers).
    </>
  );
}
